/**
 * @author vishwadeep.kapoor
 * @Date: 2018-08-23 15:05:41
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-11-26 15:58:27
 */

import React from 'react';
import { shape, string, bool, number } from 'prop-types';

import { Popover } from 'antd';
import StyledEGiftCard from './StyledEGiftCard';
import NoImage from '../../assets/images/no-image-320x200.jpg';
// import { GETDELIVERY_TIME } from './constants';

function selectedImage(isVariationSelected, product_image, image) {
  if (isVariationSelected && product_image) {
    return product_image;
  }
  return image ? image.url : NoImage;
}

function EGiftCard(props) {
  // const { CardName, Discount, CardImage, cardValue } = props;
  const { isVariationSelected,
    cardData: { name, image, discounts_percent },
    clientid,
    isBankCard,
    quantity,
    isMobileWindow,
    variationObj: { variationValue, price, product_image } } = props;
  let giftCardValue = variationValue;
  // let result = (parseFloat(giftCardValue) * parseFloat(discounts_percent && discounts_percent.payment_gateway)) / 100;
  // let savedPrice = parseFloat(giftCardValue) - result;
  const discountPersent = discounts_percent && discounts_percent.payment_gateway && parseFloat(discounts_percent.payment_gateway) > 0;
  const serviceFee = giftCardValue - price;
  const onHoverImage = (<img
    style={{ width: '400px' }}
    src={selectedImage(isVariationSelected, product_image, image)}
    alt={name}
  />);
  if (quantity > 1) {
    // result *= quantity;
    // savedPrice *= quantity;
    giftCardValue *= quantity;
  }
  return (
    <StyledEGiftCard>
      <h1 className="font-20">{name}</h1>
      <div className="offer_card">
        <div className="product_img">
          {clientid && clientid === 'payment_gateway' &&
            discountPersent ?
            (<div className="ribbon"><span><b>{discounts_percent && discounts_percent.payment_gateway}</b>% Off</span></div>) : ''}
          {!isMobileWindow ?
            <Popover content={onHoverImage} placement="right">
              <img
                className="width-100"
                src={selectedImage(isVariationSelected, product_image, image)}
                alt={name}
              />
            </Popover>
            :
            <img
              id="imageZoom"
              onTouchStart={() => document.getElementById('imageZoom').style.transform = 'scale(1.5)'}
              onTouchEnd={() => document.getElementById('imageZoom').style.transform = 'scale(1)'}
              src={selectedImage(isVariationSelected, product_image, image)}
              alt={name}
            /> }
          {/* <div className="share">
            <a href="#/"><FontAwesomIcon name="share-alt" /></a><br />
            <a href="#/"><FontAwesomIcon name="heart" /></a>
          </div> */}
        </div>
        <br clear="all" />
        {/* <div className="price sm-none">
          <h2>Total</h2>
          {clientid === 'payment_gateway' && discountPersent ? (
            <span>
              <span>&#8377;&nbsp;{savedPrice}</span> <strike>&#8377;&nbsp;{giftCardValue}</strike>
              <b>(You Save:&#8377;&nbsp;{result})</b>
            </span>) : (<span>&#8377;&nbsp;{giftCardValue}</span>)}
          <hr />
        </div> */}
        {isBankCard && (
          <table className="sm-none">
            <tbody>
              <tr>
                <th>Value</th>
                <th>Service Fee</th>
                <th>Price</th>
              </tr>
              <tr>
                <td>&#8377;&nbsp;{price}</td>
                <td>&#8377;&nbsp;{serviceFee}</td>
                <td>&#8377;&nbsp;{giftCardValue}</td>
              </tr>
            </tbody>
          </table>)}
        <br clear="all" />
        <div className="footer">
          {/* <h2>Delivery Time: <b>{delivery_value}</b></h2> */}
          {/* <h2>Delivery Time: <b>{GETDELIVERY_TIME(productName, delivery_value)}</b></h2> */}
        </div>
      </div>
    </StyledEGiftCard>
  );
}

EGiftCard.defaultProps = {
  isBankCard: false,
};
EGiftCard.propTypes = {
  cardData: shape({}).isRequired,
  clientid: string.isRequired,
  variationObj: shape({}).isRequired,
  quantity: number.isRequired,
  isBankCard: bool,
  isVariationSelected: bool.isRequired,
  isMobileWindow: bool.isRequired,
};

export default EGiftCard;



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/EGiftCard.js